import React from 'react';
import useGetPrepaymentSuggestion from './hooks/useGetPrepaymentSuggestion';
import DotsLoading from 'components/loadings/dotsLoading';

import RregisteredOffersPrepaymentItem from './RregisteredOffersPrepaymentItem';
interface RregisteredOffersPrepaymentProps {
  postType: string;
  guid: string;
  setIsOpenOfferPrepayment: (isOpenOffer: boolean) => void;
}
const RregisteredOffersPrepayment = ({
  guid,
  postType,
  setIsOpenOfferPrepayment,
}: RregisteredOffersPrepaymentProps) => {
  const {data, isLoading} = useGetPrepaymentSuggestion(guid);

  return (
    <div className="flex flex-col w-full gap-4 pb-2">
      <div className="flex justify-between items-center text-gray-6 font-normal text-[18px]">
        <h4>پیشنهادات ثبت شده</h4>
        <button
          className="icon-close text-[15px]"
          onClick={() => setIsOpenOfferPrepayment(false)}
        />
      </div>
      <div className="w-full">
        <div className="flex w-full items-center justify-between py-3 text-green-1 text-[16px]">
          <div className="pr-3 w-[30%] flex items-center justify-center" />
          <div className="text-gray-6 w-[30%] flex items-center justify-center">
            مقدار محصول
          </div>
          <div className="text-gray-6 w-[30%]  flex items-center justify-center">
            قیمت
            <span className="text-[12px]">(هر کیلو)</span>
          </div>

          <div className="w-[10%] flex items-center justify-center" />
        </div>
      </div>
      <div className="flex flex-col w-full  [&>*:nth-child(odd)]:bg-light-gray overflow-y-auto max-h-[60vh] [&>*:nth-child(even)]:bg-white">
        {isLoading ? (
          <DotsLoading />
        ) : (
          data
            ?.map((item, index) => (
              <RregisteredOffersPrepaymentItem
                key={index}
                profile_type={item.profile_type}
                price={item.price}
                name={item.profile.name}
                created_at={item.created_at}
                guid={guid}
                postType={postType}
              />
            ))
            .reverse()
        )}
      </div>
    </div>
  );
};

export default RregisteredOffersPrepayment;
